// Tiny read-only PostgREST client. No SDK — the anon key is SELECT-only by RLS.
import { SUPABASE_URL, SUPABASE_ANON_KEY } from "./config.js";

export async function sb(pathAndQuery) {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/${pathAndQuery}`, {
    headers: {
      apikey: SUPABASE_ANON_KEY,
      Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
    },
  });
  if (!res.ok) {
    throw new Error(`Supabase ${res.status}: ${await res.text()}`);
  }
  return res.json();
}

// PostgREST caps every response at db-max-rows (1000 on this instance),
// regardless of any ?limit=. For tables that exceed that (daily_occupancy)
// page through with Range headers until a short page is returned.
export async function sbAll(pathAndQuery, pageSize = 1000) {
  const all = [];
  for (let from = 0; ; from += pageSize) {
    const res = await fetch(`${SUPABASE_URL}/rest/v1/${pathAndQuery}`, {
      headers: {
        apikey: SUPABASE_ANON_KEY,
        Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
        "Range-Unit": "items",
        Range: `${from}-${from + pageSize - 1}`,
      },
    });
    if (!res.ok) {
      throw new Error(`Supabase ${res.status}: ${await res.text()}`);
    }
    const page = await res.json();
    all.push(...page);
    if (page.length < pageSize) return all;
  }
}
